<template>
    <v-container>
        <div v-if="isIphone" class="text-center">
            <div class="img-builder">
                <v-img class="ma-3" :src="imgPlaceholder" width="200"/>
            </div>

            <v-alert icon="mdi-information-outline" color="primary" prominent border="top" >
                {{ $t('payment.account_without_plan') }}
                <br>
                {{ $t('payment.account_without_plan_redirect') }}
            </v-alert>
        </div>
        <select-plan
            v-else
            with-coupon
            @change="plan = $event"
            @plan="showConfirm"
            @coupon="couponId = $event"
        />
        <div class="text-center mt-6">
            <logout-button small outlined/>
        </div>
        <kimsa-confirm
            ref="confirmModal"
            :title="$t('common.notice')"
            :content="confirmMessage"
            :loading="loading"
            :persistent="false"
            @confirm="save"
            :close-on-confirm="false"
        />
    </v-container>
</template>

<script>

import SelectPlan from '@/components/coach/SelectPlan'
import firebase, {db} from "@/utils/Firebase";
import KimsaConfirm from "@/components/common/KimsaConfirm";
import {mapActions} from "vuex";
import LogoutButton from "@/components/common/inputs/LogoutButton";

export default {
    components: {
        LogoutButton,
        KimsaConfirm,
        SelectPlan,
    },
    data() {
        return {
            plan: null,
            loading: false,
            confirmMessage: '',
            couponId: null,
        }
    },
    computed: {
        isCurrentSubscriptionFree(vm = this) {
            return vm.plan?.isFree || false
        },
        paymentMethodId(vm = this) {
            return vm.account?.stripeAccount?.paymentMethod?.id || null
        },
    },
    methods: {
        ...mapActions(['bindUserAccount']),
        subscribePlanCoach: firebase.functions().httpsCallable('httpPayments-subscribePlanCoach'),
        showConfirm() {
            const vm = this
            if (!vm.isCurrentSubscriptionFree && !vm.paymentMethodId)
                return vm.toast(vm.$t('payment.no_has_credit_card'), 'error')

            vm.confirmMessage = vm.$t('coach.confirm_plan')
            let isTrialEnded = vm.account?.stripeAccount?.trialEnded || false
            if (!isTrialEnded) vm.confirmMessage = `<b>${vm.$t('coach.yet_free_days')}</b> ${vm.confirmMessage}`
            vm.$refs.confirmModal.show()
        },
        async save() {
            const vm = this
            vm.loading = true
            await vm.setSubscriptionCoachPlan()
            vm.$refs.confirmModal.hide()
            await vm.bindUserAccount(vm.currentUser)
            vm.loading = false
            await vm.$router.push({name: 'coach.home'})
        },
        async setSubscriptionCoachPlan() {
            const vm = this

            const daysForTrial = vm.account?.stripeAccount?.fromFree ? 30 : vm.plan?.daysForTrial || null

            let subscribePayload = {
                planId: vm.plan.priceId,
                isFree: vm.plan.isFree === true,
                addTrial: true,
                couponId: vm.couponId,
                daysForTrial: daysForTrial,
            }

            await vm.subscribePlanCoach(subscribePayload).then(result => {
                console.log('subscribe result', result)
                console.log(vm.$t('payment.subscription_successful'))
            }).catch(async err => {
                console.log(`${vm.$t('payment.subscription_failed')}: ${err.message}`)
                if (err.message.includes('Your card was declined')) {
                    vm.toast(vm.$t('coach.payment_method_declined_redirect'), 'error')
                    await db.collection('users').doc(vm.currentUser.uid).update({'stripeAccount.paymentMethod': null})
                    await vm.bindUserAccount(vm.currentUser)
                    await vm.$router.push({name: 'coach.credit-card', query: {deleted: 'true'}})
                }
            })
        }
    },
}
</script>

<style scoped>

.img-builder {
    display: inline-block;
    border: 1px solid rgba(0,0,0,0.1);
    margin: auto auto 5%;
    background: rgba(0,0,0,0.03);
    border-radius: 5px;
}

</style>